export type TestimonialSummerCamp = {
  name: string
  image: string
  darkText?: string
  subHeading: string
  rating: string
  content: string
}

export const TESTIMONIAL: TestimonialSummerCamp[] = [
  {
    name: 'Arnesh',
    image: `arnesh.png`,
    darkText: 'India',
    subHeading: 'Grade 4, Codingal Student',
    rating: '4.5',
    content:
      'I started learning programming at an early age. Codingal method is working for me with the right level of content and techniques. Thank you Codingal.',
  },
  {
    name: 'Gladys',
    image: 'gladys.png',
    darkText: 'Oman',
    subHeading: 'Grade 8, Codingal Student',
    rating: '4.5',
    content:
      'Codingal personalized the course for me and allowed me to learn coding at my own pace from the comfort of home.',
  },
  {
    name: 'Melvin Rutto',
    image: 'melvin.png',
    darkText: 'Kenya',
    subHeading: 'Grade 6, Codingal Student',
    rating: '4.5',
    content:
      "My teacher at Codingal was the best guide I could've asked for as they really customized the classes to match my learning style.",
  },
  {
    name: 'Azka Arkananta',
    image: 'azka.png',
    darkText: 'Indonesia',
    subHeading: 'Grade 1, Codingal Student',
    rating: '4.5',
    content:
      'Excellent classes with complete module and dashboard. It is fun learning to code with real tools and languages.',
  },
  {
    name: 'Debashis Roy',
    image: 'debashis.png',
    darkText: 'COO in MNC',
    subHeading: 'Codingal Parent',
    rating: '4.5',
    content:
      'My child is so happy to have joined Codingal and really loves to be part of a thriving community of coders.group corporation.',
  },
  {
    name: 'Eva Meshack',
    image: 'eva.png',
    darkText: 'Researcher',
    subHeading: 'Codingal Parent',
    rating: '',
    content:
      "Codingal's well-structured courses have made coding fun for my son. They're the best and the quickest.",
  },
]

export const ARAB_TESTIMONIAL: TestimonialSummerCamp[] = [
  {
    name: 'Hadiqah Riyadh',
    image: `hadiqah.png`,
    subHeading: 'Grade 1, Codingal Student',
    rating: '4.5',
    content:
      'The teachers at Codingal are very knowledgeable, warm and supportive. I am happy learning to code under their guidance.',
  },
  {
    name: 'Hafsa Lodhi',
    image: 'hafsa.png',
    subHeading: 'Codingal Parent',
    rating: '4.5',
    content:
      'The customisable courses at Codingal give my child a real advantage: academically, socially, and in technology. Highly recommended!',
  },
  {
    name: 'Muhammed Mustafa',
    image: 'muhammad.png',
    subHeading: 'Grade 1, Codingal Student',
    rating: '4.5',
    content:
      'Learning to code has boosted my self-confidence and brought me closer to my aspirations of joining a big technology company.',
  },
  {
    name: 'Rubiya Abdul Wahid ',
    image: 'rubiya.png',
    subHeading: 'Codingal Parent',
    rating: '4.5',
    content:
      'Codingal actually makes coding so much fun that my child now spends her free time creating things with his new skills.',
  },
  {
    name: 'Babar',
    image: 'babar.png',
    subHeading: 'Grade 5, Codingal Student',
    rating: '4.5',
    content:
      'Codingal offers an enhanced code learning experience compared to free resources and helped me learn faster.',
  },
  {
    name: 'Faiza Khalid',
    image: 'faiza.png',
    subHeading: 'Codingal Parent',
    rating: '',
    content:
      'Codingal teachers know that each child is different and fully personalize the learning experience to suit the child.',
  },
]
